import NavNewPageItem from "./nav-new-page-item";
import { useState, useRef, useContext, useEffect } from "react";
import TableContext from "../../contexts/table-context";
import BusinessContext from "../../contexts/business-context";
import Spinner from "./spinner";
import DynamicIcon from "./dynamic-icon";
import { useTranslations } from "next-intl";

const CreateNewFolder = ({ folderNames, toggleCreate, isCreateActive, folderPermission }) => {
    const [isSaving, setIsSaving] = useState(false);
    const { createTable } = useContext(TableContext);
    const { setNotificationContent } = useContext(BusinessContext);
    const inputRef = useRef(null);
    const cancelClickedRef = useRef(false);
    const t = useTranslations('nav');
    const tTable = useTranslations('table');

    const tableTranslations = {
        columns: {
            task: tTable('columns.task'),
            status: tTable('columns.status'),
            assignedTo: tTable('columns.assignedTo'),
            text: tTable('columns.text'),
            name: tTable('columns.name'),
            objectives: tTable('columns.objectives'),
            keyResults: tTable('columns.keyResults')
        },
        statusOptions: {
            toDo: tTable('statusOptions.toDo'),
            inProgress: tTable('statusOptions.inProgress'),
            done: tTable('statusOptions.done')
        },
        names: {
            kanban: tTable('names.kanban'),
            untitledTable: tTable('names.untitledTable'),
            untitledDocument: tTable('names.untitledDocument'),
            okrs: tTable('names.okrs'),
            newFolder: tTable('names.newFolder')
        }
    };

    useEffect(() => {
        if (isCreateActive && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isCreateActive]);

    const handleCreateFolder = (folderName) => {
        if (folderNames.includes(folderName)) {
            setNotificationContent({
                showNotification: true,
                header: 'Folder name already exists',
                message: <div>Folder name <strong>{folderName}</strong> already exists, please choose another name.</div>,
                icon: 'circle-alert',
            })
            setTimeout(() => {
                setNotificationContent({
                    showNotification: false,
                })
            }, 5000);
            return;
        }
        setIsSaving(true);
        const callback = (json) => {
            setIsSaving(false);
            toggleCreate();
        }
        createTable('folder', folderName, callback, folderPermission, tableTranslations);
    }

    return (
        // <div>
            isCreateActive ? (
                <div className="flex items-center justify-between custom-text-grey-500 relative group lg:rounded-[4px] flex lg:max-w-[214px] max-w-[239px] w-full custom-bg-white-50 text-[12px] h-[35px] px-[8px]">
                    <input
                        ref={inputRef}
                        className="w-full outline-none poppins-medium bg-[transparent]"
                        type="text"
                        defaultValue={tTable('names.newFolder')}
                        onBlur={(e) => {
                            if (cancelClickedRef.current) {
                                cancelClickedRef.current = false;
                                return;
                            }
                            handleCreateFolder(e.target.value);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleCreateFolder(e.target.value)
                            }
                        }}
                        onFocus={(e) => e.target.select()}
                    />
                    {isSaving ? (
                        <Spinner size={14} />
                    ) : (
                        <span
                            onMouseDown={(e) => { e.preventDefault(); cancelClickedRef.current = true; }}
                            onClick={(e) => { e.stopPropagation(); toggleCreate(); }}
                        >
                            <DynamicIcon name='x' color='cursor-pointer' size={14} />
                        </span>
                    )}
                </div>
            ) : (
                // folderNames.length === 0 && 
                <NavNewPageItem onClick={() => { toggleCreate() }} icon="folder-plus">{t('newFolder')}</NavNewPageItem>
            )

        // </div>
    );
}
export default CreateNewFolder;